// Must be imported before any component library to configure compat behavior
// eslint-disable-next-line import/no-extraneous-dependencies
import { configureCompat } from '@vue/compat';

configureCompat({
	MODE: 2,
	// Disable Vue 2 async component detection - plain functions should be
	// treated as Vue 3 functional components (needed for @ant-design/icons-vue)
	COMPONENT_ASYNC: false,
	// Use Vue 3 functional component behavior (ant-design-vue v3 needs this)
	COMPONENT_FUNCTIONAL: false,
	// Use Vue 3 render function behavior
	RENDER_FUNCTION: false,
});
